
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import dismant from '~/images/logistic-services/dismant.png';
import loading from '~/images/logistic-services/loading.png';
import transportation from '~/images/logistic-services/transportation.png';
import instalation from '~/images/logistic-services/instalation.png';
import Image from 'next/image';
import CoorpLayout, { Title, Text } from '@/components/layout/CoorpLayout';

export default function LogisticsServicesPage() {
  const { t } = useTranslation('products');

  return (
    <CoorpLayout
      headingOne={t('products:CORPORATE_LOGISTICS_SERVICES_H1')}
      headingTwo={t('products:CORPORATE_LOGISTICS_SERVICES_H2')}
      headingThree={t('products:CORPORATE_LOGISTICS_SERVICES_H3_HERO')}
      breadcrubPages={[
        {
          name: t('products:CORPORATE_LOGISTICS_SERVICES_H1'),
          href: '/logistic-services',
        },
      ]}
    >
      <Title title={t('products:CORPORATE_LOGISTICS_SERVICES_H3_TITLE')} />
      <Text text={t('products:CORPORATE_LOGISTICS_SERVICES_P1')} />
      <div className='mb-16' />
      <MachineType
        imgSrc={dismant}
        imgAlt={t('products:CORPORATE_LOGISTICS_SERVICES_ALT')}
        title={t('products:CORPORATE_LOGISTICS_SERVICES_ITEM_1')}
        text={t('products:CORPORATE_LOGISTICS_SERVICES_ITEM_1_TEXT')}
      />
      <MachineType
        imgSrc={loading}
        imgAlt={t('products:CORPORATE_LOGISTICS_SERVICES_ALT')}
        title={t('products:CORPORATE_LOGISTICS_SERVICES_ITEM_2')}
        text={t('products:CORPORATE_LOGISTICS_SERVICES_ITEM_2_TEXT')}
      />
      <MachineType
        imgSrc={transportation}
        imgAlt={t('products:CORPORATE_LOGISTICS_SERVICES_ALT')}
        title={t('products:CORPORATE_LOGISTICS_SERVICES_ITEM_3')}
        text={t('products:CORPORATE_LOGISTICS_SERVICES_ITEM_3_TEXT')}
      />
      <MachineType
        imgSrc={instalation}
        imgAlt={t('products:CORPORATE_LOGISTICS_SERVICES_ALT')}
        title={t('products:CORPORATE_LOGISTICS_SERVICES_ITEM_4')}
        text={t('products:CORPORATE_LOGISTICS_SERVICES_ITEM_4_TEXT')}
      />
    </CoorpLayout>
  );
}

function MachineType({
  imgSrc,
  imgAlt,
  title,
  text,
}: {
  imgSrc: any;
  imgAlt: string;
  title: string;
  text: string;
}) {
  return (
    <div className='mt-4 grid w-full grid-cols-1 justify-start gap-16 pb-8 pt-8 md:grid-cols-2'>
      {/* TODO: SEO, alt doesn't exists in translations */}
      <Image src={imgSrc} alt={imgAlt} />
      <div>
        <Title isLeft hasDivider={false} title={title} />
        <Text isLeft text={text} />
      </div>
    </div>
  );
}


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/logistic-services/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  